<mat-progress-spinner
  color="primary"
  mode="indeterminate"
  value="50"
  diameter="50"
></mat-progress-spinner>
